import * as htmlToImage from "html-to-image";

export const takeScreenShot = async (node) => {
  const dataURI = await htmlToImage.toJpeg(node, { backgroundColor: "#e7e9f3" });
  return dataURI;
};

export const download = (image, { name = "creatives-metrics", extension = "jpg" } = {}) => {
  const a = document.createElement("a");
  a.href = image;
  a.download = createFileName(extension, name);
  a.click();
};

const createFileName = (extension = "", ...names) => {
  if (!extension) {
    return "";
  }

  return `${names.join("")}.${extension}`;
};
